const ar = {
  Header: {
    Home: "الرئيسية",
    Services: "الخدمات",
    Projects: "المشاريع",
    ContactUs: "اتصل بنا",
    English: "الإنجليزية",
    Arabic: "العربية",
  },
  DevelopmentProcess: {
    title: "عملية التطوير لدينا",
    meetAndPlan: {
      title: "الاجتماع والتخطيط",
      description: "تحديد متطلبات المشروع",
    },
    design: {
      title: "التصميم",
      description: "تحديد العلامة التجارية والألوان والخطوط",
    },
    development: {
      title: "التطوير",
      description: "تثبيت البرمجيات والترميز",
    },
    launch: {
      title: "الإطلاق",
      description: "اختبار عبر المتصفحات والأجهزة المختلفة وبدء الدعم المستمر",
    },
  },
  Footer: {
    company: "الشركة",
    team: "فريقنا",
    services: "الخدمات",
    projects: "المشاريع",
    contactUs: "اتصل بنا",
    businessAnalysis: "تحليل الأعمال",
    graphicDesign: "تصميم الجرافيك",
    uiUxDesign: "تصميم UI/UX",
    webDevelopment: "تطوير الويب",
    mobileDevelopment: "تطوير المحمول",
    ai: "الذكاء الاصطناعي",
    contactTitle: "اتصل بنا",
    phone: "+20 109 154 8180",
    email: "info@dramcode.top",
    socialMedia: {
      facebook: "فيسبوك",
      instagram: "إنستغرام",
      twitter: "تويتر",
      linkedin: "لينكدإن",
    },
  },
  HeroSection: {
    title: {
      we: "نحن",
      implement: "ننفذ",
      corporateSoftware: "البرمجيات المؤسسية",
    },
    description:
      "نقوم بتنفيذ برامج الأداء المؤسسي لإنشاء منتجات برمجية متميزة لدفع أعمالك إلى المستوى التالي.",
    contactUs: "اتصل بنا",
  },
  SocialIcons: {
    followUs: "تابعنا",
  },
  Services: {
    ourServices: "خدماتنا",
    readMore: "اقرأ المزيد",
    readLess: "اقرأ أقل",
    servicesTitle: "الخدمات المقدمة من الشركة",
    About: "من نحن",
    company: "شركة",
    description:
      "نقوم بتنفيذ برامج الأداء المؤسسي لإنشاء منتجات برمجية متميزة لدفع أعمالك إلى مستوى آخر.",
  },
  Project: {
    Title: "مشاريعنا",
  },
  Team: {
    Title: "فريقنا",
  },
  ContactForm: {
    ContactUs: "اتصل بنا",
    Description:
      "نحن هنا لمساعدتك سواء كان لديك سؤال حول خدماتنا أو كنت مستعدًا لبدء مشروع برمجي جديد.",
    NamePlaceholder: "اكتب اسمك هنا",
    PhonePlaceholder: "اكتب رقم هاتفك هنا",
    TitlePlaceholder: "اكتب عنوان موضوعك",
    DescriptionPlaceholder: "اكتب الوصف",
    SendButton: "إرسال",
    PhoneMessage: "يرجى كتابة رمز البلد قبل الرقم. سيعمل الرقم على WhatsApp.",
    SuccessTitle: "نجاح",
    SuccessMessage: "تم إرسال النموذج بنجاح!",
    ErrorTitle: "خطأ",
    ErrorMessage: "حدث خطأ أثناء إرسال النموذج",
    OkButton: "موافق",
    ImageAlt: "صورة الاتصال",
  },
  Projects: {
    All: "الكل",
    ProjectsWeDeveloped: "المشاريع التي قمنا بتطويرها",
    NoCategories: "لا توجد فئات متاحة.",
    NoProjects: "لا توجد مشاريع متاحة.",
    Loading: "...تحميل",
    category: "الفئة",
  },
};
export default ar;
